import AccountsSection from 'features/accounts/sections/AccountsSection';
import CustomerSimplifiedDTO from 'features/customer/dtos/CustomerSimplifiedDTO';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useCustomerSimplified } from 'features/customer/hooks/useCustomerSimplified';
import AccountSimplifiedDTO from 'features/accounts/dtos/AccountSimplifiedDTO';
import { useTranslation } from 'react-i18next';

interface RouteProps {
  customerId: string;
}

const CustomerAccounts = () => {
  // translation
  const tLabels = useTranslation("shared\\moduleNames").t;

  const history = useHistory();
  const { customerId } = useParams<RouteProps>();
  const { customer } = useCustomerSimplified(customerId, true);

  // handlers
  const accountDetailClickHandler = (account: AccountSimplifiedDTO) => {
    history.push({
      pathname: `accounts/${account.accountId}`,
      state: customer
    });
  };

  // render
  return (
    <>
      <Header
        title={tLabels("customerAccounts.title")}
        subtitle={customer ? customer.name : ""}
        includeBreadcrumbs
        links={[{ to: "/customers", text: tLabels("allCustomerSelect.title") }]}
      />
      <ModuleContent>
        <AccountsSection 
          customerId={customerId} 
          onAccountDetailClick={accountDetailClickHandler}
          forAdminUse
        />
      </ModuleContent>
    </>
  )
}

export default CustomerAccounts;
